import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';
import { staticInboxes } from '@/components/Inbox/inbox.const.js';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

export const loading = buildGetterObject('loading');
export const useInboxes = buildGetterObject('useInboxes');
export const inboxesMapping = buildGetterObject('inboxesMapping');
export const useInbox = buildGetterObject('useInbox');

const getters = {
	[loading.getter]: ({ loading }) => loading,
	[inboxesMapping.getter]: ({ inboxes }) => inboxes,
	[useInboxes.getter]: (state, getters) => Object.values(getters[inboxesMapping.getter]).sort((a, b) => b.id - a.id),
	[useInbox.getter]: (state, getters) => (id) => getters[inboxesMapping.getter][id] || staticInboxes.find(({ id }) => id === id),
};

export default getters;
